module.exports = __webpack_public_path__ + "img/art-14.8f46fce1.png";